import { gql } from '@grandvisionhq/graphql';

const appointment = gql`
  fragment BookAppointmentResult on Appointment {
    id
    status
    isReservation
    store {
      code
    }
    appointmentType {
      name
    }
    startTime
    endTime
    invitee {
      firstName
      lastName
      phone
      email
    }
    child {
      firstName
      lastName
      dateOfBirth
    }
    preferredChannelOfCommunication
    customerComment
    createdBy
    products {
      ... on SunglassesVariant {
        sku
        displayName
        prices {
          discountedPrice {
            price {
              amount
              currencyCode
            }
          }
          originalPrice {
            amount
            currencyCode
          }
        }
        media {
          images {
            url
          }
        }
      }
    }
  }
`;
const failures = gql`
  fragment FailureMessage on AppointmentFailure {
    message
  }
`;
const BOOK_APPOINTMENT = gql`
  mutation BookAppointment($data: BookAppointmentInput!) {
    bookAppointment(data: $data) {
      appointment {
        ...BookAppointmentResult
      }
      failures {
        ...FailureMessage
      }
    }
  }
  ${appointment}
  ${failures}
`;

export { BOOK_APPOINTMENT };
//# sourceMappingURL=book-appointment.js.map
